import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const customerListStyle = StyleSheet.create({
    searchContainer: {
        flex: 1,
        marginRight: 10
    },
    addCustomerButtonStyle: {
        backgroundColor: appColors?.primary,
        borderRadius: 10,
        paddingVertical: 10,
        marginRight: 5
    },
    optionContainer: {
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "flex-end",
        marginHorizontal: 15,
        gap: 10,
        marginVertical: 5,
    },
    optionInnerContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: "center",
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
    },
    optionTextStyle: {
        color: appColors.grey,
        paddingHorizontal: 5,
        fontSize: fontSize?.smallerFontSize
    },
    cardContainerStyle: {
        flex: 1,
        borderRadius: 8,
        marginBottom: 5
    },
    firstContainer: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    secondContainer: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    nameContainer: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 5
    },
    mailContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    editOptionContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        alignSelf: "flex-end",
    },
    editOptionInnerContainer: {
        width: 40,
        height: 40,
        borderRadius: 10,
        backgroundColor: appColors?.lightBackgroundColor,
        justifyContent: "center",
        alignItems: "center"
    },
    popoverView: {
        flex: 1,
        backgroundColor: appColors.light,
        borderRadius: 8,
        paddingVertical: 5,
        paddingTop: 5
    },
    optionListView: {
        margin: 5,
        borderColor: appColors?.grey,
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 7,
        borderTopColor: appColors?.lightGrey,
    },
    badgeTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.dark,
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
        paddingHorizontal: 10,
        height: 25,
    }
})